import { createIcon } from './factory'
import Bold from './warning.bold.svg?react'
import Duotone from './warning.duotone.svg?react'
import Fill from './warning.fill.svg?react'
import Regular from './warning.regular.svg?react'

export const Warning = createIcon({
  regular: Regular,
  bold: Bold,
  fill: Fill,
  duotone: Duotone,
})
